import React from 'react'
import { Box, Link, Paper, Typography } from '@mui/material'
import classNames from 'classnames'
import './Changelog.scss'

const Changelog = ({ className }) => {
  return (
    <Box className={classNames(className, 'changelog')}>
      <Typography variant="h5">変更履歴</Typography>
      <Paper className="content">
        <Box>
          <Typography variant="h6">2022-04-22</Typography>
          <Typography className="item">
            左ペインを閉じているときに新たなチャットを Snackbar に表示するようにしました.
          </Typography>
          <Typography className="item">
            ボード正解時に1着だけでなく解答権数の人数だけボーナスを与えるようにしました.
          </Typography>
          <Typography className="item">
            ボード解答送信時にボードが開いてしまうことがある問題に対応しました.
          </Typography>
        </Box>
        <Box>
          <Typography variant="h6">2022-04-17</Typography>
          <Typography className="item">
            ボードオープン時に正誤判定されていないテキストが表示されない問題に対応しました.
          </Typography>
          <Typography className="item">
            ダークテーマのスタイルを調整しました.
          </Typography>
        </Box>
        <Box>
          <Typography variant="h6">2022-04-13</Typography>
          <Typography className="item">
            ダークテーマを導入しました. 個人設定で変更できます.
          </Typography>
          <Typography className="item">
            設定をプレイ設定と個人設定に分けました. また個人設定は入室前でも設定できるようにしました.
          </Typography>
          <Typography className="item">
            以前までブラウザに保存されていた情報はリセットされます. お手数ですが設定を変更されていた方は再度設定をお願いします.
          </Typography>
        </Box>
        <Box className="all-changelog">
          <Link href="/manual/changelog" target="_blank">すべての変更履歴</Link>
        </Box>
      </Paper>
    </Box>
  )
}

export default Changelog
